import { render } from "./APIReservations.vue?vue&type=template&id=15c65618&ts=true"
import script from "./APIReservations.vue?vue&type=script&lang=ts"
export * from "./APIReservations.vue?vue&type=script&lang=ts"

import "./APIReservations.vue?vue&type=style&index=0&id=15c65618&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__